export const environment = {
  production: false,
  environmentName: 'dev',
  url: 'https://enova-dev-ag.vanti.tech',
  base_url: 'https://enova-dev-ag.vanti.tech/',
  prediction_url: 'https://enova-dev-ag.vanti.tech/prediccion/',
  admin_url: 'https://enova-dev-ag.vanti.tech/administracion/',
  consumption_url: 'https://enova-dev-ag.vanti.tech/consumos/',
  sso: {
    appId: '6875786d3c77e7a6d54f4553',
    url: 'https://iam-dev.vanti.tech/login?app_id=6875786d3c77e7a6d54f4553',
  },
  datadog: {
    clientToken: 'pubd2cd522ad682499454a8e2b391377a50',
    applicationId: 'f3231d67-d81d-4047-8494-a245b4a998b3',
    site: 'datadoghq.com',
    service: 'TALLERES',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
  },
};
